import { useRouter } from 'vue-router';

// Lifetime singleton (same pattern as the `chime` in useChatSoundNotifications):
// the listener has no reason to be torn down, and keeping the flag set avoids
// the premature-reset hazard if a second consumer ever mounts concurrently.
let registered = false;

/**
 * Window-side half of the service worker `notificationclick` fallback.
 * Windows opened before the current SW version activated are uncontrolled,
 * so `client.navigate()` throws for them — the SW posts `sw:navigate`
 * instead and we route via vue-router here.
 */
export const useSwNavigationListener = () => {
  const router = useRouter();

  if (registered || !('serviceWorker' in navigator)) {
    return;
  }

  registered = true;

  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    const data = event.data as { type?: string; url?: string } | null;

    // Only in-app paths: the tag contract is always a relative URL, anything
    // else (absolute/external) is dropped defensively.
    if (
      data?.type === 'sw:navigate'
      && typeof data.url === 'string'
      && data.url.startsWith('/')
      && !data.url.startsWith('//')
    ) {
      void router.push(data.url);
    }
  });
};
